import { gql } from '@apollo/client';

export * from './users.query.generated';

export const USERS = gql`
  query users(
    $perPage: Int
    $page: Int
    $orderBy: UserColumnsEnum
    $order: QueryOrderEnum
    $queryFilter: String
    $role: UserRoleEnum
  ) {
    users(perPage: $perPage, page: $page, orderBy: $orderBy, order: $order, queryFilter: $queryFilter, role: $role) {
      nodes {
        id
        role
        email
        name
        phone
        policy {
          remove
          transferOwnership
          update
        }
      }
      nodesCount
      hasNextPage
      hasPreviousPage
      pagesCount
    }
  }
`;
